import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { User } from '../../users/user.interface';
import { UserService } from './user.service';

const service = new UserService();

export interface UserState {
   taskUsers: Array<User>;
}

const UserStore: Module<UserState, StoreState> = {
   namespaced: true,
   state: {
      taskUsers: [],
   },
   getters: {},
   mutations: {
      SET_TASK_USERS(state, taskUsers: Array<User>) {
         state.taskUsers = taskUsers;
      },
   },
   actions: {
      async getTaskUsers(context, query: LocationQuery) {
         const response = await service.getTaskUsers(query['search'], query);
         return response;
      },
      async getTaskUsersByTaskId(context, query: LocationQuery) {
         const response = await service.getTaskUsersByTaskId(query['taskId'], query['search'], query);
         return response;
      },
   },
   modules: {},
};

export default UserStore;
